<template>
	<el-dialog width="550px" :visible.sync="visible" :fullscreen="true" :title="!dataForm.id ? $t('add')+'企业用户' : $t('update')+'企业用户'" :close-on-click-modal="false" :close-on-press-escape="false">
		<el-form :model="dataForm" style="padding-right: 50px;" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
		<el-row>
			<el-col :md="8" :lg="6">
				<el-form-item prop="userCode" label="编码">
					<el-input v-model="dataForm.userCode" placeholder="编码" disabled></el-input>
				</el-form-item>
			</el-col>
			<el-col :md="8" :lg="6">
				<el-form-item label="用户类型">
					<el-input value="企业用户" placeholder="用户类型" disabled></el-input>
				</el-form-item>
			</el-col>
			<el-col :md="8" :lg="6">
				<el-form-item prop="caName" label="企业名称">
					<el-input v-model="dataForm.caName" placeholder="企业名称" :disabled="!dataForm.id ? false : true"></el-input>
				</el-form-item>
			</el-col>
			<el-col :md="8" :lg="6">
				<el-form-item prop="username" label="用户名称">
					<el-input v-model="dataForm.username" placeholder="用户名称"></el-input>
				</el-form-item>
			</el-col>
			<el-col :md="8" :lg="6">
				<el-form-item prop="mobile" label="手机号">
					<el-input v-model="dataForm.mobile" placeholder="手机号" autocomplete="off"></el-input>
				</el-form-item>
			</el-col>
			<el-col :md="8" :lg="6">
				<el-form-item prop="password" :label="$t('user.password')" :class="{ 'is-required': !dataForm.id }">
					<el-input v-model="dataForm.password" type="password" :placeholder="$t('user.password')" autocomplete="new-password" class="ipt"></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		<el-form-item label="服务费承担方" prop="serviceFeeType">
			<el-checkbox-group v-model="dataForm.serviceFeeType" :disabled="dataForm.id ? true : false">
			<el-checkbox label="0">企业承担服务费</el-checkbox>
			<el-checkbox label="1">个人承担服务费</el-checkbox>
			</el-checkbox-group>
		</el-form-item>
		<el-form-item label="税源地" prop="bodyId">
			<el-select class="select-body" v-model="dataForm.bodyId" filterable placeholder="请选择" >
				<el-option
					v-for="item in bodyInfo"
					:key="item.id"
					:label="item.abbreviation"
					:value="item.id"
					class="option-body">
				</el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="企业来源" prop="sourceOrg">
			<el-select class="select-body" v-model="dataForm.sourceOrg" filterable placeholder="请选择"  clearable>
				<el-option label="海茵科技" value="HY" class="option-body"></el-option>
			</el-select>
		</el-form-item>
		<el-form-item label="开票设置" prop="settintUserList">
			<el-button type="primary" @click="handleSetting()">设置</el-button>
			<input type="text" :hidden="true" v-model="settintUserList">
			<div class="checkUser" v-if="settintUserList.length > 0">已设置:&nbsp;&nbsp;
				<el-tag v-for="(item,index) in settintUserList" type="" :key="index">{{item.ticketProject}}</el-tag>
			</div>
		</el-form-item>
		<el-form-item>
			<el-checkbox v-model="dataForm.deactivate" true-label="yes" false-label="no">停用</el-checkbox>
		</el-form-item>
		</el-form>
		<template slot="footer">
			<el-button @click="visible = false">{{ $t('cancel') }}</el-button>
			<el-button type="primary" @click="dataFormSubmitHandle()" :loading="loadingbut">{{ $t('confirm') }}</el-button>
		</template>
		<userSetting ref="userSetting" @handleUserList="handleUserList" :settintUserList="settintUserList"/>
	</el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { isEmail, isMobile,testPassword } from '@/utils/validate'
import aesJs from '../../../utils/login-aes'
import userSetting from "./user-setting.vue"
export default {
	data () {
		return {
			settintUserList:[],
			visible: false,
			roleList: [],
			roleIdListDefault: [],
			loadingbut: false,
			dataForm: {
			serviceFeeType:['0'],
			id: '',
			userType: 'qyyh',
			caName: '',
			username: '',
			password: '',
			deactivate: 'no',
			mobile: '',
			bodyId:'',
			sourceOrg:'',
		},
		bodyInfo: [],
		}
	},
	components:{
		userSetting
	},
	computed: {
		dataRule () {
			var validateName = (rule, value, callback) => {
			if(!value){
				callback('必填项不能为空')
			}
				callback()
			}
			var validateMobile = (rule, value, callback) => {
				if (!isMobile(value)) {
					return callback(new Error(this.$t('validate.format', { 'attr': this.$t('user.mobile') })))
				}
				callback()
			}
			var checkpassword = (rule, value, callback) => {
				//根据 this.dataForm.id判断
				if(!!this.dataForm.id){
					//  修改
					if(!!value){
						if(!testPassword(value)){
							callback(new Error('请设置8到12位数字，大写、小写字母，符号，至少三种'))
						}
						callback()
					}
					callback()
				}else{
					//  新增
					if(testPassword(value)){
					callback()
					}else{
					callback(new Error('请设置8到12位数字，大写、小写字母，符号，至少三种'))
					}
				}
			}
			return {
				caName: [{ required: true, validator:validateName, trigger: 'blur' }],
				mobile: [{ required: true, message: '输入正确的电话号码', validator: validateMobile, trigger: 'blur' }],
				// settintUserList:[{ required: true, message: this.$t('validate.required'), trigger: 'change' }],
				username: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
				password: [{ required: false,validator: checkpassword,trigger: 'blur'}],
				serviceFeeType:[{ required: true, message: this.$t('validate.required'), trigger: 'change' }],
				bodyId:[{ required: true, message: this.$t('validate.required'), trigger: 'change' }]
			}
		}
	},
	methods: {
		init () {
			this.visible = true
			this.$nextTick(() => {
				this.$refs['dataForm'].resetFields()
				this.getBodyInfo();
				if (this.dataForm.id) {
					this.getInfo();
				}else{
					this.dataForm = {
						serviceFeeType:['0'],
						id: '',
						userType: 'qyyh',
						caName: '',
						username: '',
						password: '',
						deactivate: 'no',
						mobile: '',
						bodyId:'',
			            sourceOrg:'',

					}
				}
				this.settintUserList = [];
				if(this.$refs.userSetting.$refs.multipleTable) this.$refs.userSetting.$refs.multipleTable.clearSelection()
			})
		},
		handleUserList(item){
			this.settintUserList = item;
			this.$refs.dataForm.validateField('settintUserList');
		},
		handleSetting(){
			if(this.dataForm.bodyId){
				this.$refs.userSetting.dataForm.bodyId = this.dataForm.bodyId;
				this.$refs.userSetting.init();
			}else{
				this.$message.error('请先选择税源地!')
			}
		},
		// 获取信息
		getInfo () {
			this.$http.get(`/sys/user/getInfoById?id=${this.dataForm.id}`).then(({ data: res }) => {
				if (res.code !== 0) {
					return this.$message.error(res.msg)
				}
				this.dataForm = {
					...this.dataForm,
					...res.data,
					// bodyId:''
				}
				console.log(this.dataForm)
				// this.dataForm.deactivate = (res.data.status == 0 ? 'yes' : 'no')
				this.dataForm.serviceFeeType = this.dataForm.caBodyDTOS[0].serviceFeeType ? this.dataForm.caBodyDTOS[0].serviceFeeType.split(",") : []
				this.dataForm.bodyId = this.dataForm.caBodyDTOS[0].bodyId || '';
				let newList = this.dataForm.caBodyDTOS[0].taskTypes;
				this.settintUserList = newList || []
				// this.dataForm.caBodyDTOS = null
				
			}).catch(() => {})
		},
		// 表单提交
		dataFormSubmitHandle: debounce(function () {
			this.$refs['dataForm'].validate((valid) => {
				if (!valid) {
					return false
				}
				if(this.settintUserList.length < 1){
					this.$message.error('请设置开票项目!');
					return false
				}
				//名称中的中文括号替换成英文括号
				this.dataForm.caName = this.dataForm.caName.replace('（','(');
				this.dataForm.caName = this.dataForm.caName.replace('）',')');
				this.dataForm.username = this.dataForm.username.replace('（','(');
				this.dataForm.username = this.dataForm.username.replace('）',')');
				this.dataForm.serviceFeeType = this.dataForm.serviceFeeType.join(",");
				this.dataForm.taskTypes = this.settintUserList
				let url = '/sys/plat/info/ca/create'
				if (this.dataForm.id > 0) {
					url = '/sys/plat/info/ca/update'
					this.dataForm.userId = this.dataForm.id
				}
				this.loadingbut = true
				let paramsForm = JSON.parse(JSON.stringify(this.dataForm));
				paramsForm.password = paramsForm.password ? aesJs.encrypt(paramsForm.password) : ''
				paramsForm = {...paramsForm,caBodyDTOS:[{...paramsForm}]}
				this.$http.post(url, {
					...paramsForm,
				}).then(({ data: res }) => {
				this.loadingbut = false
				if (res.code !== 0) {
					this.dataForm.serviceFeeType  = this.dataForm.serviceFeeType ? this.dataForm.serviceFeeType.split(",") : []
					return this.$message.error(res.msg)
				}
				this.$message({
					message: this.$t('prompt.success'),
					type: 'success',
					duration: 500,
					onClose: () => {
					this.visible = false
					this.$emit('refreshDataList')
					}
				})
				}).catch(() => {})
			})
		}, 1000, { 'leading': true, 'trailing': false }),
		// 获取税源地列表
		getBodyInfo() {
			this.$http.get(`/sys/plat/body/page?order=&orderField=&page=1&limit=1000&sydEdit=1`).then(({ data: res }) => {
				this.bodyInfo = res.data.list;
			})
		}
	}
	}
	</script>

	<style lang="scss" scoped>
	.mod-sys__user {
	.dept-list {
		.el-input__inner,
		.el-input__suffix {
		cursor: pointer;
		}
	}
	.role-list {
		.el-select {
		width: 100%;
		}
	}
	}
	.select-body{
	width: 100%;
	}
	.option-body.selected{
	color: #459FFB!important;
	}
	.ipt {
	/deep/ .el-input__inner {
		-webkit-text-security:disc!important;
	} 
	}
</style>
